export default "__VITE_ASSET__CadLg2$r__"